import React, { useEffect, useRef, useState } from 'react'
import style from "css/address.module.css";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import AddressPopup from './addressPopup';
import { useTranslation } from 'react-i18next';

function MoreIcon({ info, deleteAddress, openData, isLastCard }) {
    const { t } = useTranslation();

    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const [isMorePopupOpen, setIsMorePopupOpen] = useState(false);

    const moreBtnHandler = () => {
        setIsMorePopupOpen(!isMorePopupOpen);
    }

    const editBtnHandler = () => {
        openData(info);
        setIsMorePopupOpen(false);
    }

    // 더보기 상자가 열렸을 때 다른 곳을 터치하면 상자가 닫히도록
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)) {
                setIsMorePopupOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
        <div className={style.addr_more_wrapper}>
            <div ref={buttonRef} className={style.addr_more_container} onClick={moreBtnHandler}>
                <div className={style.addr_more_dot}></div>
                <div className={style.addr_more_dot}></div>
                <div className={style.addr_more_dot}></div>
            </div>
            <div
                ref={menuRef}
                className={style.addr_more_popup}
                style={{ display: isMorePopupOpen ? "flex" : "none", top: isLastCard ? "-95px" : "25px" }}
            >
                <button
                    className={style.popupBtn}
                    onClick={editBtnHandler}
                >
                    <EditOutlined style={{ fontSize: "18px" }} />
                    {t("BTN.MODIFY2")}
                </button>
                <button
                    className={style.popupBtn}
                    onClick={() => deleteAddress(info.key)}
                >
                    <DeleteOutlined style={{ fontSize: "18px" }} />
                    {t("BTN.DELETE2")}
                </button>
            </div>
        </div>
    )
}

export default MoreIcon
